/**
 * THIS IS A CUSTOM BUTTON WITH A ROUNDED ICON AND A FLOWBITE-REACT BUTTON
 * @param {React.ReactNode} icon - Icon to display in the button
 * @param {string} ariaLabel - Aria label for the button
 * @param {ButtonProps} props - Props for the flowbite-react button
 */

import { createElement, isValidElement } from "react";
import { Button, ButtonProps } from "flowbite-react";
import type { LucideIcon } from "lucide-react";

type RoundedIconButtonProps = ButtonProps & { icon: LucideIcon, ariaLabel: string, className?: string };

export const RoundedIconButton = ({
  icon, ariaLabel, className, ...props
}: RoundedIconButtonProps) => (
  <Button
    {...props}
    type="button"
    color="transparent"
    aria-label={ariaLabel}
    className={`w-10 h-10 p-2 flex justify-center items-center rounded-full focus:ring-0 transition-colors duration-200 text-lightmuted ${className || ""}`}
  >
    {isValidElement(icon) ? icon : createElement(icon, { size: 20 })}
  </Button>
);

export default RoundedIconButton;
